<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="rect">
      您的评价对我们很重要！评价内容将会公开展示
      <van-rate
        v-if="isFirst"
        v-model="formData.socre"
        class="score"
        :size="25"
        color="#E32119"
        void-icon="star"
        void-color="#ddd"
      />
      <div class="commentRect">
        <textarea v-model="commentBody" class="commentBody" rows="6" :maxlength="maxFont" />
        <div class="commnetFontNum">还可以输入{{ maxFont-nowFont }}字</div>
      </div>
      <van-uploader
        v-model="fileList"
        class="imageUpload"
        multiple
        :max-count="5"
        :after-read="afterRead"
      />
      <div class="anonymous">
        <van-checkbox v-model="formData.isAnonymous" class="checkBox">匿名评论</van-checkbox>
      </div>
    </div>
    <div class="EmptyRect" />
    <div class="downButton">
      <van-button type="info" :loading="buttonLoading" @click="onComment">提交评论</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, MyNotify, compressorImageList } from '@/utils/base'
import { Button, Rate, Uploader, Checkbox } from 'vant'
export default {
  components: {
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Uploader.name]: Uploader,
    [Checkbox.name]: Checkbox,
    TopBar
  },
  data() {
    return {
      title: '评价',
      backurl: '/store/orderList',
      maxFont: 1000,
      nowFont: 0,
      commentBody: '',
      buttonLoading: false,
      isFirst: undefined,
      fileList: [],
      formData: {
        socre: 0,
        body: '',
        isAnonymous: false,
        type: 'COMMODITY',
        code: 0,
        orderId: undefined,
        resType: 'TEXT',
        res: ''
      }
    }
  },
  watch: {
    commentBody(newValue, oldValue) {
      this.nowFont = newValue.length
      this.formData.body = newValue
    }
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    this.formData.orderId = this.$route.params.id
    this.isFirst = getUrlKey('isFirst')
    if (this.isFirst === null) {
      this.isFirst = undefined
    }
    console.log('this.isFirst', this.isFirst)
  },
  methods: {
    afterRead(file) {
      console.log('file', file)
    },
    uploadImg(callback) {
      var noFile = true
      var fileList = []
      this.fileList.map((value, index, array) => {
        if (value.file) {
          fileList.push(value.file)
          noFile = false
        }
      })
      if (noFile) {
        if (callback) {
          callback()
        }
        return
      }
      compressorImageList(fileList, 1024, 1024, 0.6, (list) => {
        const formData = new FormData()
        list.map((value, index, array) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        request({
          url: '/Data/uploadFile?config=storecomment',
          method: 'post',
          data: formData
        }).then(response => {
          console.log('上传图片反馈', response)
          if (!response.success) {
            this.buttonLoading = false
            return
          }
          var list = []
          response.data.map((value, index, array) => {
            list.push(value.save)
          })
          this.formData.res = list.toString()
          if (callback) {
            callback()
          }
        })
      })
    },
    onComment() {
      if (this.isFirst && this.formData.socre === 0) {
        MyNotify('error', '请给我们进行评分!')
        return
      }
      this.buttonLoading = true
      this.uploadImg(() => {
        // 上传数据
        request({
          url: '/Store/AddComment',
          method: 'post',
          data: this.formData
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          MyNotify('success', '发布评价成功', 3000)
          this.$router.replace(this.backurl)
        })
      })
    }
  }
}
</script>
<style scoped>
.rect{
    padding: 1em 1em 0 1em;
    background-color: #fff;
    border-bottom: 1px solid #dadada;
}
.rect .score{
    margin-top: 0.6em;
}
.rect .commentRect{
    margin-top: 1em;
    border: 1px solid #cacaca;
    padding: 0.5em;
}
.rect .commentBody{
    width: 99%;
    resize: none;
    border: none;
}
.rect .commnetFontNum{
    text-align: right;
    font-size: 0.7em;
    color: #999;
}
.rect .imageUpload{
  margin-top: 1em;
}
.rect .anonymous{
height: 3em;
position: relative;
}
.rect .anonymous .checkBox{
  width: 7em;
  font-size: 0.7em;
  height: 3em;
  position: absolute;
  right: 0;
}
.EmptyRect{
  height: 3em;
}
.downButton{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 2;
}
.downButton button{
  width: 100%;
}
</style>

